import React, { useMemo, useState } from "react";
import style from "./index.module.scss";
import Statics from "../Statics";
import { getVoteFilter, StuVoteItem, VoteContent } from "service/vote";
import useQuery from "utils/useQuery";
import Search from "../Search";
import { ColumnProps } from "antd/lib/table/interface";
import moment from "moment";
import { Table } from "antd";
import VoteSelect from "./components/VoteSelect";
import _ from "underscore";

interface VoteStuTableProp {
    voteInfo: VoteContent;
    stuList: StuVoteItem[];
}

export default function VoteStuTable({ voteInfo, stuList }: VoteStuTableProp) {
    const { status } = useQuery<{ status: string }>();
    const [searchText, setSearchText] = useState("");
    const [filterStatus, setFilterStatus] = useState(status || "all");

    const filters = useMemo(
        () => getVoteFilter(voteInfo.type, voteInfo.answersNumber, stuList),
        [voteInfo, stuList]
    );

    function onFilterStatus(value: any, record: StuVoteItem) {
        if (value === "--" && record.voteStatus === "0") return true; // 未投票
        const selected = record.voteInfo?.map(item => item.content) || [];
        return selected.includes(value);
    }

    const columns: ColumnProps<StuVoteItem>[] = [
        {
            title: "序号",
            render: (text, item, index) => index + 1,
            align: "center",
            width: 100,
            key: "index"
        },
        {
            title: "班级",
            dataIndex: "className",
            align: "center",
            width: 300
        },
        {
            title: "学生信息",
            dataIndex: "name",
            render: renderStudent
        },
        {
            title: "投票情况",
            dataIndex: "voteStatus",
            render: (voteStatus: string, item) => (
                <VoteSelect voteInfo={voteInfo} data={item} />
            ),
            align: "center",
            width: 120,
            filters: filters,
            onFilter: (value, record) => onFilterStatus(value, record)
        },
        {
            title: "投票时间",
            dataIndex: "voteTime",
            align: "center",
            width: 200,
            render: (text: string) =>
                text ? moment(text).format("MM-DD HH:mm:ss") : "",
            sorter: (itemA, itemB) =>
                itemA.voteTime > itemB.voteTime ? 1 : -1,
            sortDirections: ["ascend", "descend"]
        }
    ];

    // 学生信息
    function renderStudent(text: string, item: StuVoteItem) {
        return (
            <div className={style.student}>
                {text}
                <span className={style.stuNo}>{item.studentNo}</span>
            </div>
        );
    }

    const filteredList = useMemo(() => {
        return stuList
            .filter(
                item =>
                    item.name?.indexOf(searchText) !== -1 ||
                    item.studentNo === searchText
            )
            .filter(item => {
                // 投票状态
                if (filterStatus === "all") return true;
                if (filterStatus === "vote" && item.voteStatus === "1")
                    return true;
                return filterStatus === "unVote" && item.voteStatus === "0";
            });
    }, [searchText, filterStatus, stuList]);

    // 统计数据
    const statics = useMemo(() => {
        return _.reduce(
            stuList,
            (memo, item) => ({
                courseStuCount: memo.courseStuCount + 1,
                voteStuCount:
                    memo.voteStuCount + (item.voteStatus === "1" ? 1 : 0),
                notVoteStuCount:
                    memo.notVoteStuCount + (item.voteStatus === "0" ? 1 : 0)
            }),
            { courseStuCount: 0, voteStuCount: 0, notVoteStuCount: 0 }
        );
    }, [stuList]);

    return (
        <div className={style.root}>
            <div className={style.header}>
                <Statics
                    {...statics}
                    current={filterStatus}
                    onChange={setFilterStatus}
                />
                <Search onChange={setSearchText} className={style.search} />
            </div>

            <div className={style.table}>
                <Table
                    columns={columns}
                    dataSource={filteredList}
                    rowKey="studentNo"
                    pagination={false}
                />
            </div>
        </div>
    );
}
